import React from "react";
import "./ComplaintFormContent.scss";

function ComplaintFormAlertBox() {
    return (
        <aside className={"complaintForm_alertInLine"}>
            <div className={"complaintForm_content2"}>
                <div className={"complaintForm_contentarea"}>
                    <div className={"complaintForm_icontext"}>
                        <img
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/f2d20270adf2c37adfa59a5694ac8c8d56e529b00f8b244f64528a5e7c0f913a?placeholderIfAbsent=true&apiKey=d992e37b49744a81ba42f501e4b4a8a3"
                            alt="Information icon"
                            className={"complaintForm_img"}
                        />
                        <div className={"complaintForm_titlebody"}>
                            <strong>Don't forget:</strong> if you've got a question or you
                            need help using our service, you'll need to contact us via live
                            chat – we can't respond to questions we receive via this form.
                        </div>
                    </div>
                </div>
            </div>
        </aside>
    );
}

export default ComplaintFormAlertBox;
